export const FILES_LIMIT = 20;
export const SF_FILE_SIZE_LIMIT_MB = 25;
export const supportedFileTypes: string[] = ['*/*']; // All file types

export const nameMatches = {
    exactMatches: ['name', 'locationname'],
    keywords: ['name', 'location', 'venue', 'poi', 'place'],
};

export const addressMatches = {
    latMatches: ['lat', 'latitude', 'y', 'ycoordinate'],
    lngMatches: ['lng', 'long', 'longitude', 'x', 'xcoordinate'],
    exactOnlyMatches: new Set(['x', 'y']),
    streetMatches: ['street', 'streetaddress', 'addressline1'],
    cityMatches: ['city', 'town', 'municipality'],
    stateMatches: ['state', 'region', 'province'],
    fullAddressMatches: ['address', 'fulladdress', 'formattedaddress'],
};

export const zipCodeMatches = {
    exactMatches: ['zipcode', 'postalcode', 'zip', 'postcode'],
    keywords: ['zip', 'postal', 'code'],
};
